import { inject, InjectionToken } from '@angular/core';

export const TEST_ID_TOKEN = new InjectionToken<string>('');

export const ProvideTestId = (suffix: string) => ({
  provide: TEST_ID_TOKEN,
  useFactory: () => {
    const parentTestId = inject(TEST_ID_TOKEN, { optional: true, skipSelf: true });
    return parentTestId ? `${parentTestId}-${suffix}` : suffix;
  }
});
